module.exports = __webpack_public_path__ + "4755b516eec77070e741f1a518c492c3.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/happy-20.png
// module id = 2148
// module chunks = 0